import { CapoPlugin } from "/home/zebrafashion/zebrafashion.com/releases/75947690/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];